import { Col } from "react-bootstrap";

export const ProjectCard = ({ title, description, imgUrl, link }) => {
  return (
    <Col size={12} sm={6} md={4}>
      <div className="proj-imgbx">
        {/* <img src={imgUrl} /> */}
        <div className="proj-txtx">
          <h4>{title}</h4>
          <span>{description}</span>
          <div className="proj-link">
      {link && (
          <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-visit-page"
          >
            Visit Page
          </a>
        )}
      </div>
        </div>
      </div>
    </Col>
  );
};
